import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';
import Page1 from './pages/Page1';

function App() {
  return (
    <Router future={{ v7_relativeSplatPath: true }}>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <AnimatePresence mode="wait">
          <Routes>
            <Route path="/" element={<Page1 />} />
          </Routes>
        </AnimatePresence>
      </div>
    </Router>
  );
}

export default App;
